import {getId} from 'apis/model/base'
import classNames from 'classnames'
import copyToClipboard from 'copy-to-clipboard'
import {ROOT_URL} from 'envs/_current/config'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React, {useContext, useMemo, useState} from 'react'
import createStickySider from 'views/AppLocals/factory/createStickySider'
import {NullAsDefault, renderIf} from 'views/Shared'
import {FollowButton} from '../../../../components/Feed/FollowButton'
import categoryIcons from '../../../../conts/categoryIcons'
import useTranslate from '../../../../modules/local/useTranslate'
import UserContext from '../UserContext'
import UserChannels from './UserChannels'
import UserOrganizations from './UserOrganizations'
import {Avatar, message} from "antd";
import {UserShareWidget} from "../../factory/createShareWidget";
import {HeaderButton} from "../../../Organization/components/PageHeader";
import {PiChats, PiLinkSimpleBold} from "react-icons/pi";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {renderIfElse} from "../../../Shared";
import {paths} from "../../../MainPage/contains";
import {Link} from "react-router-dom";
import TooltipApp from "components/TooltipApp";
import {ConversationWith} from "../../factory/createChatButton";
import {WrapperBlockSider} from "../../Organization/components/WrapperBlockSider";
import {BsHeartFill, BsPersonFillGear} from "react-icons/bs";
import {channel_getChannelsByUser_Api, organization_getOrganizationsByUser_Api} from "../../../../apis";
import {renderLoading} from "../../functions/renderers/renderLoading";
import {bindQueryParam} from "../../functions/routerHelper";
import {BiSolidChurch} from "react-icons/bi";
import getAvatar from "../../../../helpers/getAvatar";
import getTitle from "../../../../helpers/getTitle";
import {OrgType} from "../../Organization/components/OrgType";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {renderShowMore} from "../../../MainPage/functions/renderLimitLoadMore";
import {renderChannelItem} from "../../../MainPage/functions/renderChannelItem";
import {RiSignalTowerFill} from "react-icons/ri";

const ListWrapper = ({style, title, className, children}) => {
    const t = useTranslate()
    return (
        <div
            style={style}
            className={classNames('flex flex-col gap-3', className)}>
            <div className="uppercase text-color-300 font-medium pb-1 border-b border-color-50">
                {t(title)}
            </div>
            <div className="flex flex-col gap-3">{children}</div>
        </div>
    )
}

const FavouriteCategories = () => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {user} = useContext(UserContext)
    const categories = Array.from(user?.categories ?? [])

    return renderIf(
        categories.length,
        <div className="flex flex-col gap-3">
            <WrapperBlockSider
                borderRight={true} titleColor="text-indigo-700"
                icon={<BsHeartFill size={18} className="text-indigo-400"/>}
                title="favourites categories">
                <div className="flex flex-wrap gap-3">
                    {categories.map((e, i) => {
                        const Icon = _.get(categoryIcons, getId(e), categoryIcons['default']) ?? NullAsDefault
                        return (
                            <Link
                                key={i}
                                to={
                                    paths.categoryPath
                                        .replace(':category', e?.id)
                                }
                                style={{padding: '4px 10px'}}
                                className="w-fit flex flex-center gap-2 border border-indigo-500 hover:shadow-md hover:scale-2xs rounded-md no-underline">
                                <Icon size={14}/>
                                <span className="font-semibold text-sm text-indigo-600 italic leading-tight">
                                    {e.name}
                                </span>
                            </Link>
                        )
                    })}
                </div>
            </WrapperBlockSider>
        </div>
    )
}

const Channels = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const apiInfo = channel_getChannelsByUser_Api
    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', user?.id)].join('/'),
        [user?.id]
    )
    const [limit, setLimit] = useState(3)

    return (
        <UserChannels
            user_id={getId(user)}
            renderWrap={(child, __, count) =>
                renderIf(
                    count > 0,
                    <WrapperBlockSider
                        borderTop={true} titleColor="text-blue-600"
                        icon={<RiSignalTowerFill size={18} className="text-blue-500"/>}
                        title="channels">
                        <div className="flex flex-col gap-4">
                            <CustomLazyPaginationWrapper
                                sample={limit}
                                auto={true}
                                key={refreshKey}
                                apiInfo={apiInfo}
                                renderLoading={renderLoading}
                                renderItem={renderChannelItem}
                                query={bindQueryParam({ id: user?.id })}
                                renderLoadMoreButton={renderShowMore([limit, setLimit])}
                            />
                        </div>
                    </WrapperBlockSider>
                )
            }
        />
    )
}

const Organizations = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const apiInfo = organization_getOrganizationsByUser_Api
    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', user?.id)].join('/'),
        [user?.id]
    )
    const [limit, setLimit] = useState(5)

    return (
        <UserOrganizations
            user_id={getId(user)}
            renderWrap={(child, __, count) =>
                renderIf(
                    count > 0,
                    <WrapperBlockSider
                        borderTop={true} titleColor="text-blue-600"
                        icon={<BsPersonFillGear size={18} className="text-blue-500"/>}
                        title="join the community">
                        <div className="flex flex-col gap-4">
                            <CustomLazyPaginationWrapper
                                sample={limit}
                                auto={true}
                                key={refreshKey}
                                apiInfo={apiInfo}
                                renderLoading={renderLoading}
                                renderItem={(item) => (
                                    <div className="px-3 py-2 hover:shadow-md rounded-lg hover:scale-2xs flex flex-col gap-1 custom-item-render relative">
                                        <div className="mb-2 pb-2 border-b flex items-center gap-2">
                                            <Avatar
                                                size={40}
                                                icon={<BiSolidChurch size={18} className="text-primary-600"/>}
                                                src={getAvatar(item)}
                                                className="flex flex-center bg-primary-50 rounded-md"
                                            />
                                            <div className="flex flex-col flex-1 truncate">
                                                <Link
                                                    to={getLinkToDetail(item)}
                                                    className="flex-1 font-bold text-sm text-color-000 no-underline leading-snug truncate">
                                                    {getTitle(item)}
                                                </Link>
                                                <OrgType item={item} className="font-medium text-2xs text-blue-500 italic leading-tight"/>
                                            </div>
                                        </div>
                                        <div className="flex justify-end">
                                            <FollowButton
                                                size="small"
                                                item={item}
                                            />
                                        </div>
                                    </div>
                                )}
                                query={bindQueryParam({ id: user?.id })}
                                renderLoadMoreButton={renderShowMore([limit, setLimit])}
                            />
                        </div>
                    </WrapperBlockSider>
                )
            }
        />
    )
}

const Content = () => {
    const t = useTranslate()
    const {user} = useContext(UserContext)
    const {isSm} = useContext(LayoutContext)
    const shareUrl = `${ROOT_URL}${getLinkToDetail(user)}`

    return (
        <div className="flex flex-col gap-6">
            {renderIfElse(
                isSm,
                <div className="flex items-center gap-3">
                    <UserShareWidget
                        className="gap-2"
                        header={
                            <span className="text-sm text-color-400 italic">
                        {`${t('share')} : `}
                    </span>
                        }
                        footer={
                            <HeaderButton
                                onClick={() => {
                                    copyToClipboard(shareUrl)
                                    message.success(t('copied'))
                                }}
                                width={24}
                                height={24}
                                icon={
                                    <TooltipApp title={t('copy link')} placement="right"
                                                classNames={{root: "text-xs italic"}}>
                                        <PiLinkSimpleBold size={12}/>
                                    </TooltipApp>
                                }
                            />
                        }
                    />
                    <div className="flex-1"/>
                    <FollowButton item={user} size="medium"/>
                    {renderIf(
                        user?.follow_status === true,
                        <ConversationWith
                            params={{receiver_id: getId(user)}}
                            render={(__, {onClick}) => (
                                <div
                                    onClick={onClick}
                                    className="flex flex-center bg-blue-100 rounded-md text-blue-500 hover:text-blue-700 cursor-pointer"
                                    style={{width: 28, height: 28}}>
                                    <PiChats size={16}/>
                                </div>
                            )}
                        />
                    )}
                </div>,
                <div className="h-3"/>
            )}
            <FavouriteCategories/>
            {renderIfElse(
                !isSm,
                <Channels/>
            )}
            {renderIfElse(
                !isSm,
                <Organizations/>
            )}
            {renderIf(
                !isSm,
                <React.Fragment>
                    <div className="h-3"/>
                    <UserShareWidget
                        className="gap-2"
                        header={
                            <span className="text-sm text-color-400 italic">
                                {`${t('share')} : `}
                            </span>
                        }
                        footer={
                            <HeaderButton
                                onClick={() => {
                                    copyToClipboard(shareUrl)
                                    message.success(t('copied'))
                                }}
                                width={24}
                                height={24}
                                icon={
                                    <TooltipApp title={t('copy link')} placement="right">
                                        <PiLinkSimpleBold size={12}/>
                                    </TooltipApp>
                                }
                            />
                        }
                    />
                    <div className="h-3"/>
                </React.Fragment>
            )}
        </div>
    )
}

const UserSider = ({Wrapper = 'div', stickySider = true}) =>
    createStickySider({
        Wrapper,
        stickySider,
    })(Content)

export default UserSider
